export const planIds = {
  basic: "plan-revvenu-basic",
  essentials: "plan-revvenu-essentials",
  pro: "plan-revvenu-pro",
};

export const customerId = "customer-demo-01";
